// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__WrC4W","consentsList":"PatientConsents_consentsList__1L8AD","consentsListEmpty":"PatientConsents_consentsListEmpty__2PsXc"};